/* Illume Research theme JS — attestation gate, mobile nav, cart drawer, variant picker, catalogue filter, quote form */
(function () {
  "use strict";

  var GATE_VERSION = "2026-07-v1";
  var GATE_KEY = "illume-research:access-attestation";

  /* ---------- money ---------- */
  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en", {
        style: "currency",
        currency: currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD",
      }).format(cents / 100);
    } catch (e) {
      return "$" + (cents / 100).toFixed(2);
    }
  }

  /* ---------- attestation gate ---------- */
  function gateAccepted() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(GATE_KEY) || "null");
      return !!(parsed && parsed.accepted === true && parsed.version === GATE_VERSION);
    } catch (e) {
      return false;
    }
  }

  function initGate() {
    var gate = document.getElementById("attestation-gate");
    if (!gate) return;
    if (!gateAccepted()) {
      gate.classList.add("is-open");
      document.body.style.overflow = "hidden";
    }
    var checkboxes = gate.querySelectorAll("input[type=checkbox]");
    var acceptBtn = gate.querySelector("[data-gate-accept]");
    var declineBtn = gate.querySelector("[data-gate-decline]");
    var main = gate.querySelector("[data-gate-main]");
    var declined = gate.querySelector("[data-gate-declined]");
    var backBtn = gate.querySelector("[data-gate-back]");

    function refresh() {
      var all = Array.prototype.every.call(checkboxes, function (c) { return c.checked; });
      if (acceptBtn) acceptBtn.disabled = !all;
    }
    checkboxes.forEach(function (c) { c.addEventListener("change", refresh); });
    refresh();

    if (acceptBtn)
      acceptBtn.addEventListener("click", function () {
        window.localStorage.setItem(
          GATE_KEY,
          JSON.stringify({ accepted: true, version: GATE_VERSION, acceptedAt: new Date().toISOString() })
        );
        gate.classList.remove("is-open");
        document.body.style.overflow = "";
      });
    if (declineBtn)
      declineBtn.addEventListener("click", function () {
        if (main) main.classList.add("hidden");
        if (declined) declined.classList.remove("hidden");
      });
    if (backBtn)
      backBtn.addEventListener("click", function () {
        if (declined) declined.classList.add("hidden");
        if (main) main.classList.remove("hidden");
      });

    document.querySelectorAll("[data-gate-reset]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        window.localStorage.removeItem(GATE_KEY);
        window.location.reload();
      });
    });
  }

  /* ---------- mobile nav ---------- */
  function initNav() {
    var toggle = document.querySelector("[data-nav-toggle]");
    var nav = document.getElementById("mobile-nav");
    if (!toggle || !nav) return;
    toggle.addEventListener("click", function () {
      var open = nav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      toggle.querySelector("[data-icon-menu]").classList.toggle("hidden", open);
      toggle.querySelector("[data-icon-close]").classList.toggle("hidden", !open);
    });
  }

  /* ---------- cart drawer ---------- */
  var drawer, drawerBody, drawerFoot;

  function renderCart(cart) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = cart.item_count;
      el.setAttribute("data-count", cart.item_count);
    });
    if (!drawerBody) return;

    if (!cart.items.length) {
      drawerBody.innerHTML =
        '<div class="cart-drawer__empty">' +
        '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
        '<p class="text-white" style="font-size:14px;font-weight:600">Your request basket is empty</p>' +
        '<p class="mt-2 text-2xs text-dim" style="max-width:20rem">Add an available research compound to begin an institutional order request.</p>' +
        '<a class="btn btn--outline btn--sm mt-6" href="' + (window.theme.catalogueUrl || "/collections/all") + '">View catalogue</a>' +
        "</div>";
      if (drawerFoot) drawerFoot.classList.add("hidden");
      return;
    }

    var html = cart.items
      .map(function (item) {
        return (
          '<article class="cart-line" data-line-key="' + item.key + '">' +
          '<div class="cart-line__row">' +
          '<div class="cart-line__media">' +
          (item.image
            ? '<img src="' + item.image + (item.image.indexOf("?") > -1 ? "&" : "?") + 'width=160" alt="' + (item.title || "").replace(/"/g, "&quot;") + '" loading="lazy">'
            : '<span class="mono-label eyebrow--sm" style="color:rgba(255,255,255,.3)">RUO</span>') +
          "</div>" +
          '<div style="min-width:0;flex:1">' +
          '<h3 class="cart-line__title">' + item.product_title + "</h3>" +
          (item.variant_title && item.variant_title !== "Default Title"
            ? '<p class="cart-line__variant">' + item.variant_title + "</p>"
            : "") +
          '<p class="cart-line__price">' + formatMoney(item.final_price, cart.currency) + "</p>" +
          "</div>" +
          '<button type="button" class="cart-line__remove" data-cart-remove aria-label="Remove ' + item.product_title + '">' +
          '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>' +
          "</button></div>" +
          '<div class="cart-line__controls">' +
          '<div class="qty-box">' +
          '<button type="button" data-cart-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
          "<span>" + item.quantity + "</span>" +
          '<button type="button" data-cart-qty="1" aria-label="Increase quantity">+</button>' +
          "</div>" +
          '<p class="cart-line__total">' + formatMoney(item.final_line_price, cart.currency) + "</p>" +
          "</div></article>"
        );
      })
      .join("");
    drawerBody.innerHTML = html;
    if (drawerFoot) {
      drawerFoot.classList.remove("hidden");
      var subtotal = drawerFoot.querySelector("[data-cart-subtotal]");
      if (subtotal) subtotal.textContent = formatMoney(cart.items_subtotal_price, cart.currency);
    }
  }

  function fetchCart() {
    return fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
      window.theme._cart = cart;
      renderCart(cart);
      return cart;
    });
  }

  function changeLine(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); window.theme._cart = cart; });
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    document.body.style.overflow = "hidden";
    fetchCart();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  function initCart() {
    drawer = document.getElementById("cart-drawer");
    if (drawer) {
      drawerBody = drawer.querySelector("[data-drawer-body]");
      drawerFoot = drawer.querySelector("[data-drawer-foot]");
      drawer.querySelectorAll("[data-drawer-close]").forEach(function (el) {
        el.addEventListener("click", closeDrawer);
      });
      drawer.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-cart-qty], [data-cart-remove]");
        if (!btn) return;
        var line = btn.closest("[data-line-key]");
        if (!line) return;
        var key = line.getAttribute("data-line-key");
        if (btn.hasAttribute("data-cart-remove")) return void changeLine(key, 0);
        var item = (window.theme._cart.items || []).find(function (i) { return i.key === key; });
        if (!item) return;
        var next = item.quantity + parseInt(btn.getAttribute("data-cart-qty"), 10);
        changeLine(key, Math.max(0, Math.min(99, next)));
      });
    }
    document.querySelectorAll("[data-cart-open]").forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        openDrawer();
      });
    });
    fetchCart();
  }

  /* ---------- product form (AJAX add) ---------- */
  function initProductForm() {
    var form = document.querySelector("[data-product-form]");
    if (!form) return;
    var idInput = form.querySelector("[name=id]");
    var priceEl = document.querySelector("[data-variant-price]");
    var submitBtn = form.querySelector("[data-add-button]");
    var variantData = {};
    try {
      variantData = JSON.parse(document.getElementById("product-variants-json").textContent);
    } catch (e) {}

    document.querySelectorAll("[data-variant-option]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        document.querySelectorAll("[data-variant-option]").forEach(function (b) { b.classList.remove("is-selected"); });
        btn.classList.add("is-selected");
        var id = btn.getAttribute("data-variant-id");
        if (idInput) idInput.value = id;
        var v = variantData[id];
        if (v && priceEl) priceEl.textContent = v.price;
        if (submitBtn && v) {
          submitBtn.disabled = !v.available;
          submitBtn.querySelector("[data-add-label]").textContent = v.available
            ? submitBtn.getAttribute("data-label-add")
            : submitBtn.getAttribute("data-label-unavailable");
        }
      });
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (submitBtn) submitBtn.disabled = true;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: parseInt(idInput.value, 10), quantity: 1 }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error("add failed");
          return r.json();
        })
        .then(function () { openDrawer(); })
        .catch(function () { window.location.href = "/cart"; })
        .finally(function () { if (submitBtn) submitBtn.disabled = false; });
    });
  }

  /* ---------- catalogue filter ---------- */
  function initCatalogueFilter() {
    var chips = document.querySelectorAll("[data-filter-chip]");
    if (!chips.length) return;
    var cards = document.querySelectorAll("[data-product-type]");
    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        chips.forEach(function (c) { c.classList.remove("is-active"); });
        chip.classList.add("is-active");
        var value = chip.getAttribute("data-filter-chip");
        cards.forEach(function (card) {
          var match = value === "All" || card.getAttribute("data-product-type") === value;
          card.classList.toggle("hidden", !match);
        });
      });
    });
  }

  /* ---------- quote request page ---------- */
  function initQuoteForm() {
    var form = document.querySelector("[data-quote-form]");
    if (!form) return;

    var attest = form.querySelectorAll("[data-attest]");
    var submitBtn = form.querySelector("[data-quote-submit]");
    function refresh() {
      var all = Array.prototype.every.call(attest, function (c) { return c.checked; });
      if (submitBtn) submitBtn.disabled = !all;
    }
    attest.forEach(function (c) { c.addEventListener("change", refresh); });
    refresh();

    // Compose order summary into hidden field at submit time from live cart
    form.addEventListener("submit", function () {
      var summaryField = form.querySelector("[data-quote-summary-field]");
      var cart = window.theme._cart;
      if (summaryField && cart) {
        var lines = cart.items.map(function (i) {
          return (
            i.product_title +
            (i.variant_title && i.variant_title !== "Default Title" ? " — " + i.variant_title : "") +
            " | SKU: " + (i.sku || "n/a") +
            " | Variant ID: " + i.variant_id +
            " | Qty: " + i.quantity +
            " | " + formatMoney(i.final_line_price, cart.currency)
          );
        });
        lines.push("Indicative subtotal: " + formatMoney(cart.items_subtotal_price, cart.currency));
        lines.push("Attestations confirmed: research-use-only; no human/veterinary use; authority to order; manual review accepted.");
        lines.push("Attestation version: " + GATE_VERSION);
        summaryField.value = lines.join("\n");
      }
    });

    // After a successful Shopify contact post, clear the basket
    if (window.location.search.indexOf("contact_posted=true") !== -1) {
      fetch("/cart/clear.js", { method: "POST" }).then(fetchCart);
      var success = document.querySelector("[data-quote-success]");
      var formWrap = document.querySelector("[data-quote-form-wrap]");
      if (success) success.classList.remove("hidden");
      if (formWrap) formWrap.classList.add("hidden");
    }
  }

  window.theme = window.theme || {};

  document.addEventListener("DOMContentLoaded", function () {
    initGate();
    initNav();
    initCart();
    initProductForm();
    initCatalogueFilter();
    initQuoteForm();
  });
})();
